import React, { useEffect, useState } from 'react';
import {
  Dialog,
  IconButton,
  Box,
  Typography,
  Button,
} from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { useDropzone } from 'react-dropzone';
import { useNavigate, useParams, useLocation } from 'react-router-dom'; // Correct import
// import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';


import { makeStyles } from '@material-ui/core/styles';

interface CategoryDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  onSubmitt: (values: any) => Promise<void>;
}

// Define styles using makeStyles
const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    overflow: 'hidden',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#f7f7f7',
  },
  librarySec: {
    position: 'relative',
  },
  boxRadius: {
    border: 'dashed #6F6F6F 1px',
    borderRadius: '2px',
    padding: '20px'
  },
  customDropzone: {

    backgroundColor: 'white',
    position: 'relative',
    '& svg': {
      // position: 'absolute',
      // top: '40%',
      // left: '50%',
      // transform: 'translate(-50%, -50%)',
      // textAlign: 'center',
      margin: '0px',
    },
    borderRadius: theme.shape.borderRadius,
    textAlign: 'center',
    padding: theme.spacing(4),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  cloudIcona: {
    fontSize: 60,
    color: theme.palette.grey[500],
    // marginBottom: theme.spacing(2),
  },
  uploadText: {
    // fontFamily: "Roboto",
    marginBottom: "10px",
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "28px",
    letterSpacing: "-0.06px",  // Rounded the value to 2 decimal places for consistency
    textAlign: "center",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none", 
  },
  dragText: {
    marginTop: '10px',
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    textAlign: "center",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
  },
  uploadButton: {
    // position: 'absolute',
    // top: '57%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)',
    // fontSize: '12px',
    // textAlign: 'center',
    // marginTop: theme.spacing(2),
    backgroundColor: '#EE3235 !important',
    // color: '#fff',
    // fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "12px",
    textAlign: "left",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
  },
}));

const FileUpload: React.FC<CategoryDialogProps> = ({
  open,
  onClose,
  title,
  onSubmitt,
}) => {
  const classes = useStyles();
  const [files, setFiles] = useState<File[]>([]);
  const [currentRoute, setCurrentRoute] = useState<string>('');
  const location = useLocation(); 
  
  

  const { getRootProps, getInputProps } = useDropzone({
    // accept: 'image/*,audio/*,video/*,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    accept: '.xls, .xlsx',  // Only accept Excel files
    onDrop: (acceptedFiles) => {
      setFiles(acceptedFiles); // Update local state for reference if needed
      console.log('Files dropped:', acceptedFiles);
      onSubmitt(acceptedFiles); // Pass files directly to the parent
      onClose()
    },
  });
  // const handleSubmit = () => {
  //   console.log('Files submitted:', files);
  //   onSubmitt(files); // Pass files to parent component
  // };
  useEffect(() => {
    const currentUrll = window.location.href; // or location.pathname for just the path
    setCurrentRoute(currentUrll);
  }, [location]);
  return (
    <Dialog
      onClose={onClose}
      open={open}
      fullWidth
      classes={{ paper: classes.dialogPaper }}
      PaperProps={{
        style: {
          maxWidth: '800px',
          width: '100%',
        },
      }}
    >
      <Box className={classes.customDropzone} {...getRootProps()}>
        <Typography variant="h6" className={classes.uploadText}>
          {title}
        </Typography>
        <Box className={classes.boxRadius}>
          {/* <CloudUploadOutlinedIcon className={classes.cloudIcona} /> */}
          <Box className={classes.cloudIcona}>
            <img
              src="/static/icons/cloud.png"
              alt="Edit Icons"
            />
          </Box>
          {/* Hidden file input */}
          <Box className={classes.librarySec}>

            <input {...getInputProps()} />
          </Box>

          {/* <Button
          variant="contained"
          color="primary"
          className={classes.uploadButton}
          onClick={handleSubmit}
        >
          Browse Files
        </Button> */}


          <Button
            variant="contained"
            color="primary"
            className={classes.uploadButton}
          // onClick={handleSubmit}
          // startIcon={<CloudUploadOutlinedIcon />}
          >
            <img
              src="/static/icons/upload.png"
              alt="Edit Icons"
              style={{
                marginRight: "10px",
                marginBottom: "2px",
              }}
            />
            Upload
          </Button>

        </Box>
        <Typography variant="body2" color="textSecondary" className={classes.dragText}>
          Or drag and drop your file in the box
        </Typography>
      </Box>
    </Dialog>
  );
};

export default FileUpload;
